import { AssessmentStepKey, PopulatedAssessment, StageProgress } from '@hb/shared'
import { UseSignOnComplete } from '../../hooks/backend/assessments/useSignOnComplete'

export const getPregnancyProgress = (
  assessment: PopulatedAssessment | null,
  signOnStatus: UseSignOnComplete,
) => {
  const { skippedQuestionnaire, signedOnDate, resultsViewedOn } = assessment ?? {}
  const {
    consentFormsStatus: { complete: consentFormsComplete },
  } = signOnStatus
  const { scheduledCall } = assessment ?? {}
  const getQuestionsProgress = () => {
    if (skippedQuestionnaire) {
      // if (signedOnDate) return 100
      // return 0
      return 100
    }
    switch (assessment?.status) {
      case 'incomplete':
        return 50
      case 'awaiting-questionnaire':
        return 0
      default:
        return 100
    }
  }

  const getViewProgress = () => {
    let score = 0
    if (assessment?.scheduledCall) score += 1
    if (
      assessment?.disclaimers?.disclaimer1Accepted &&
      assessment?.disclaimers?.disclaimer2Accepted
    )
      score += 1
    if (assessment?.resultsViewedOn) score += 1
    return (score / 3) * 100
  }
  const viewProgress = getViewProgress()

  const getSignOnProgress = () => {
    if (viewProgress < 100) return 0
    if (!assessment?.resultsViewedOn) return 0
    let score = 0

    if (signedOnDate) score += 1
    if (consentFormsComplete) score += 1
    return (score / 2) * 100
  }

  const questionsProgress = getQuestionsProgress()

  const viewActive = !!assessment?.sentOn && questionsProgress === 100
  const b: Record<AssessmentStepKey, StageProgress> = {
    questions: {
      name: 'Questions',
      progress: questionsProgress,
      active: true,
      visible: !skippedQuestionnaire,
    },
    view: {
      name: 'Assessment',
      progress: viewActive ? viewProgress : 0,
      active: viewActive,
      visible: !skippedQuestionnaire,
    },
    signOn: {
      name: 'Sign On',
      progress: getSignOnProgress(),
      active: !!resultsViewedOn && !!scheduledCall?.reportedOn,
      visible: true,
    },
  }

  return b
}
